module.exports = __webpack_public_path__ + "static/AbbFAMILY2010.cfe2e533.gif";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project2/AbbFAMILY2010.gif
// module id = 494
// module chunks = 8418805283199